/*
    This gets moved to be a direct child of document.body.
    It's a generic component that's very useful for overlays.
*/

import * as React from "react";
import * as ReactDOM from "react-dom";

class Portal extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public portalElement: HTMLDivElement | null = null;
    public componentDidMount(): void {
        const p = document.createElement("div");
        document.body.appendChild(p);
        this.portalElement = p;
        this.componentDidUpdate();
    }
    public componentWillUnmount(): void {
        if (this.portalElement) document.body.removeChild(this.portalElement);
    }
    public componentDidUpdate(): void {
        const { children } = this.props;
        ReactDOM.render(<div {...this.props}>{children}</div>, this.portalElement);
    }
    public render(): null {
        return null;
    }
}

export { Portal };
